import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Carousel from '../../../layouts/carousel';
import Modal from '../../../overlays/modal';
import Text from '../../../elementals/text';
import Icon from '../../../elementals/icon';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    lazyLoad: false,
    variableWidth: false,
    autoplay: false,
    _rows: 2,
    _slidesPerRow: 2,
};
const closeIcon = (_jsx(Icon, { className: 'close', name: 'times', iconStyle: 'regular', color: 'gray', fitted: true }));
const PhotoCarouselModal = props => {
    const { photos, isOpen, onClose, address, photoId, source } = props;
    const startPhoto = _.find(photos, { value: photoId }) || {};
    const photosToDisplay = _.filter(photos, {
        isSelected: startPhoto.isSelected,
    });
    const initialIndex = photosToDisplay.indexOf(startPhoto);
    return (_jsxs(Modal, { open: isOpen, onClose: onClose, className: cx('carousel-modal'), closeIcon: closeIcon, children: [_jsxs(Text, { className: 'u-pb-1', size: 'large', weight: 'heavy', children: [_jsx(Icon, { name: 'images', size: 'big', iconStyle: 'solid' }), `${source} Photos`] }), _jsx(Text, { className: 'u-pb-1', size: 'large', weight: 'medium', children: address }), _jsx(Carousel, { alwaysShowArrows: true, settings: { ...settings, initialSlide: initialIndex }, elmId: 'property_carousel', children: photosToDisplay.map((photo, i) => (_jsx("img", { height: '100%', width: '100%', src: photo.photoUrl }, i))) })] }));
};
PhotoCarouselModal.propTypes = {
    photos: PropTypes.array.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    address: PropTypes.string,
    photoId: PropTypes.string,
    source: PropTypes.string,
};
PhotoCarouselModal.defaultProps = {
    address: '',
    photoId: '',
    source: '',
};
export default PhotoCarouselModal;
//# sourceMappingURL=index.js.map